export const AvailabilityRestrictionTypes = [
    { value: 'rate', label: 'Rate' },
    { value: 'availability', label: 'Availability' },
];

export type AvailabilityRestrictionType = typeof AvailabilityRestrictionTypes[number]['value'];